// extracted by mini-css-extract-plugin
export default {"wrapper":"gC-z","addressLine":"hC-z","fullName":"iC-z"};